import { Component, OnInit, OnDestroy, Optional, Inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CustomerService, AuthService, RouterEventsService, LocationConfigService, NavbarConfigService, NavigationConfig } from 'gung-standard';
import {
  JeevesCustomerActionConfigService,
  JeevesCustomerDetailsComponent,
  JeevesCustomerDeliveryLocationListConfigService
} from 'gung-standard-jeeves';
import { environment as env } from '../../../environments/environment';
import { RefCustomerService } from '../../services/ref-customer/ref-customer.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs';

@Component({
    selector: 'ref-jeeves-customer-details',
    templateUrl: './ref-jeeves-customer-details.component.html',
    styleUrls: ['./ref-jeeves-customer-details.component.scss'],
    standalone: false
})
export class RefJeevesCustomerDetailsComponent extends JeevesCustomerDetailsComponent implements OnInit, OnDestroy {
  protected unsubscribe: Subject<void> = new Subject();
  isCapstone = env.projectName === 'capstone';
 
  
  ngOnInit() {
    const routeParams = this.route.snapshot.params;
    if (routeParams.customerId != null) {
      (this.customerService as RefCustomerService)
        .getCustomerBySubject(routeParams.customerId)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(customer => {
          this.customer = customer;
        });
    }
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
